import React from 'react';
import { TestimonialCard } from './TestimonialCard';
export function MastersSection() {
  return <div className="w-full px-6 py-20 bg-gradient-to-b from-slate-900/50 to-transparent" data-id="element-83">
      <div className="max-w-6xl mx-auto space-y-16" data-id="element-84">
        <h2 className="text-4xl md:text-5xl font-bold text-center bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent" style={{
        fontFamily: 'Oswald, sans-serif'
      }} data-id="element-85">
          WHO ARE THE MASTERS?
        </h2>
        <p className="text-xl text-center text-gray-300 max-w-4xl mx-auto font-light" data-id="element-86">
          Our two top transformation specialists and two founders of the Peptide
          Science Institute:{' '}
          <span className="text-cyan-400 font-semibold" data-id="element-87">Brenden Henry</span>,
          the world's number one authority on peptide science. And{' '}
          <span className="text-cyan-400 font-semibold" data-id="element-88">Dr. Ali Mazloum</span>,
          "The Human MRI." Both with track records of doing what most people in
          the medical world still call "impossible."
        </p>
        <TestimonialCard text="As a doctor myself, I was skeptical of anything outside standard cardiology protocols. But conventional medicine had nothing left to offer me except a new heart. What you've done isn't just impressive—it's life-changing." highlight={true} profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/vZL9KdQ2uLmKMiW9nVHZh9/689a3be16bdead10a4c0ff24.png" name="Glen S." data-id="element-89" />
        {/* Dr. Ali Mazloum */}
        <div className="relative bg-gradient-to-br from-purple-900/40 via-cyan-900/30 to-purple-900/40 border-2 border-cyan-500/40 rounded-2xl p-10 md:p-14 space-y-6 shadow-2xl shadow-cyan-500/20" data-id="element-90">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 to-cyan-600/10 blur-3xl rounded-2xl pointer-events-none" data-id="element-91" />
          <div className="relative space-y-6" data-id="element-92">
            <div className="flex justify-center mb-6" data-id="element-93">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/idMX72BXZPG3Zi3CsQr6jH/DrAli1.png" alt="Dr. Ali Mazloum" className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover border-4 border-cyan-500/50 shadow-lg shadow-cyan-500/30" data-id="element-94" />
            </div>
            <h3 className="text-4xl md:text-5xl font-bold text-center text-gray-100" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-95">
              Dr. Ali Mazloum
            </h3>
            <p className="text-2xl md:text-3xl text-center font-bold text-cyan-400" data-id="element-96">
              The Human MRI
            </p>
            <div className="space-y-5 text-base md:text-lg text-gray-200 leading-relaxed" data-id="element-97">
              <p data-id="element-98">
                The biomedical genius who operates far beyond the capabilities
                of conventional medicine and doctors. Where hospitals and
                specialists fail, Ali has diagnosed and solved cases considered
                "incurable."
              </p>
              <p data-id="element-99">
                He has reversed type 1 and type 2 diabetes, rheumatoid
                arthritis, cerebral vasculitis, asthma, eczema, COPD, Graves'
                disease, and more. He has restored kidney function in patients
                facing dialysis, reversed immune collapse and autoimmune
                diseases, eliminated chronic pain, and brought clients back from
                the brink when even the best specialists around the globe
                failed.
              </p>
              <p data-id="element-100">
                Beyond physical illness, his protocols have also resolved severe
                depression, anxiety, epilepsy, and neurological disorders that
                all resisted standard treatment.
              </p>
              <p data-id="element-101">
                Like Brenden, Ali has mastered the use of Khavinson peptides and
                more than 80 others, but his genius lies in his diagnostic
                precision.
              </p>
              <p className="text-lg md:text-xl font-bold text-cyan-300" data-id="element-102">
                Working in one of the largest hospitals in Russia, physicians
                bring him "impossible cases" because he sees what dozens of
                others have missed, sometimes within minutes.
              </p>
              <p data-id="element-103">
                He has routinely spotted overlooked pathologies on MRI, EKG, and
                lab work, then designed treatment strategies that actually work.
              </p>
              <p data-id="element-104">
                Alongside this, Ali has deep expertise in optimizing human
                performance through advanced protocols that incorporate
                hormones, testosterone, and other performance-enhancing agents,
                integrating them safely with peptides for unparalleled results
                in strength, vitality, and longevity.
              </p>
              <p className="text-xl md:text-2xl font-bold text-cyan-400" data-id="element-105">
                Elite entrepreneurs, CEOs, athletes, and even physicians
                themselves come to him when nobody else can figure out what's
                wrong. And they often experience recoveries modern medicine
                still insists are impossible.
              </p>
            </div>
          </div>
        </div>
        <TestimonialCard text="Ali… You have done what our entire team of medical professionals were not able to do." name="Badar A." profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/rdsSxPNyzo6kTft2Q6Yhgt/Screenshot_2025-11-10_200825.png" data-id="element-106" />
        {/* Brenden Henry */}
        <div className="relative bg-gradient-to-br from-purple-900/40 via-cyan-900/30 to-purple-900/40 border-2 border-cyan-500/40 rounded-2xl p-10 md:p-14 space-y-6 shadow-2xl shadow-cyan-500/20" data-id="element-107">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 to-cyan-600/10 blur-3xl rounded-2xl pointer-events-none" data-id="element-108" />
          <div className="relative space-y-6" data-id="element-109">
            <div className="flex justify-center mb-6" data-id="element-110">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/v2H34AjK9mE5mPJRiERTgj/Image_2.jpg" alt="Brenden Henry" className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover border-4 border-cyan-500/50 shadow-lg shadow-cyan-500/30" data-id="element-111" />
            </div>
            <h3 className="text-4xl md:text-5xl font-bold text-center text-gray-100" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-112">
              Brenden Henry
            </h3>
            <p className="text-2xl md:text-3xl text-center font-bold text-cyan-400" data-id="element-113">
              World's #1 Authority on Peptide Science
            </p>
            <div className="space-y-5 text-base md:text-lg text-gray-200 leading-relaxed" data-id="element-114">
              <p data-id="element-115">
                After designing life-saving ventilator systems still used in
                hospitals today, Brenden Henry turned his engineering mind to
                human biology. With an emphasis on anti-aging and longevity, he
                has gone deeper into this field than almost anyone else alive,
                thoroughly studying every major researcher and theory of aging.
              </p>
              <p data-id="element-116">
                Using this knowledge he authored Peptide Salvation and created
                Peptide Mastery, both of which contain thousands of scientific
                citations (more than any other peptide resource in the world).
                Additionally he contributed his own original research on 30+
                peptides.
              </p>
              <p className="text-lg md:text-xl font-bold text-cyan-300" data-id="element-117">
                He is the first and only person in the world to fully master the
                entire body of literature on Khavinson peptides, with many
                doctors now crediting him for providing the resources to
                implement more than 130 peptides into their practice.
              </p>
              <p data-id="element-118">
                With a desire to understand exactly how things work, he has
                obsessively studied hundreds of mechanisms, pathways, and genes
                throughout the human body. This mastery extends beyond peptides
                into supplements, medications, detoxification strategies,
                performance enhancers, and nootropics at a level few in the
                world can match.
              </p>
              <p data-id="element-119">
                His work has resulted in transformations modern medicine still
                insists are impossible: reversing autoimmune diseases,
                regenerating organs, reversing markers of aging, and even
                helping clients recover from diabetes (types 1 and 2), kidney
                failure, traumatic brain injury including stroke and Alzheimer
                disease, drug withdrawal in less than half the time of in-house
                clinics, with minimal symptoms, and heart failure.
              </p>
              <p className="text-xl md:text-2xl font-bold text-cyan-400" data-id="element-120">
                His intense, meticulous and pioneering approach has resulted in
                elite entrepreneurs, CEO's, athletes, doctors, clinicians and
                researchers all seeking his wisdom.
              </p>
            </div>
          </div>
        </div>
        <TestimonialCard text="Brenden all these so called proficient dr's in our space and we've accomplished more in 2 weeks than in the past year." profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/wu3WrEb7TMcpemyocLBB2S/Screenshot_2025-11-10_202634.png" name="Shawna C." data-id="element-121" />
      </div>
    </div>;
}